import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type EmergencyPhysicianIconProps = SvgIconProps

export function EmergencyPhysicianIcon(props: EmergencyPhysicianIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Emegrency_physician">
        <g>
          <g id="XMLID_00000165936173801436907610000001795187297816544698_">
            <g>
              <polygon
                style={{ fill: '#ED1C24' }}
                points="164.109,28.678 169.009,37.968 160.379,42.528 169.009,47.078 164.109,56.368 
					154.379,51.238 154.379,62.228 143.879,62.228 143.879,51.238 134.159,56.368 129.259,47.078 137.879,42.528 129.259,37.968 
					134.159,28.678 143.879,33.808 143.879,22.818 154.379,22.818 154.379,33.808 				"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M108.349,130.438c14.96,6.51,25.65,20.97,26.77,38.03h-0.01c-15.04,13-34.51,21.02-55.82,21.51
					l-2.62-1.21v-52.25l0.02-1.04c0.01,0,0.01,0,0.02,0c7.73-0.03,15.02-3.03,21.05-8.16l0.55,0.08
					C101.809,128.018,105.179,129.048,108.349,130.438z M119.979,162.728c0-5.55-4.51-10.05-10.06-10.05
					c-5.55,0-10.05,4.5-10.05,10.05s4.5,10.05,10.05,10.05C115.469,172.778,119.979,168.278,119.979,162.728z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M52.069,85.068c-0.89-0.95-2.08-2.4-3.13-4.38c-0.3-0.57-0.57-1.15-0.8-1.75
					c-2.78-7.02-1.2-15.4-0.85-16.75c6.64-25.17,51.6-26.85,58.68,0c0.36,1.36,1.97,9.89-0.93,16.95c-0.21,0.53-0.45,1.04-0.72,1.55
					c-1.04,1.98-2.23,3.43-3.12,4.38c0,0,0,0,0,0.02l-23.69-19.45l-0.88,8.26c-7.53-2.92-14.46-4.8-20.36-6.03
					c-0.84,1.8-1.7,3.93-2.38,6.42c-1.21,4.33-1.49,8.2-1.47,11.17c-0.11-0.13-0.24-0.24-0.35-0.37
					C52.069,85.068,52.069,85.068,52.069,85.068z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M46.029,129.978c2.86-1.16,5.86-2.03,8.97-2.58l0.22-0.02c0.11-0.02,0.22-0.04,0.33-0.06
					c6.03,5.13,13.32,8.13,21.05,8.16c0.03,0,0.06,0,0.09,0l-0.02,1.04v52.25l2.62,1.21c-0.69,0.01-1.38,0.02-2.07,0.02h-1.13
					c-22.12,0-42.36-8.11-57.89-21.53h-0.01C19.329,150.998,30.519,136.258,46.029,129.978z"
              />
            </g>
            <g>
              <circle
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                cx="149.129"
                cy="42.678"
                r="32.68"
              />
              <polygon
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="169.009,37.968 
					164.109,28.678 154.379,33.808 154.379,22.818 143.879,22.818 143.879,33.808 134.159,28.678 129.259,37.968 137.879,42.528 
					129.259,47.078 134.159,56.368 143.879,51.238 143.879,62.228 154.379,62.228 154.379,51.238 164.109,56.368 169.009,47.078 
					160.379,42.528 				"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M41.389,166.938h-7.74v-16.76c0-7.63,6.18-13.82,13.81-13.82h1.48c7.63,0,13.81,6.19,13.81,13.82v16.76h-8.84"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M45.379,134.298c0-1.5,0.23-2.96,0.65-4.32c1.85-5.97,7.41-10.3,13.97-10.3"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M94.249,119.678c6.73,0,12.41,4.56,14.1,10.76c0.34,1.23,0.52,2.52,0.52,3.86v17.35"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M119.979,162.728c0,5.55-4.51,10.05-10.06,10.05c-5.55,0-10.05-4.5-10.05-10.05s4.5-10.05,10.05-10.05
					C115.469,152.678,119.979,157.178,119.979,162.728z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M51.999,84.978c0.02,0.04,0.05,0.07,0.07,0.09"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M50.319,92.938c-0.79-2.14-3.53-0.83-5.63-5.84c-3.06-7.34,0.47-9.1,2.88-7.94"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M102.329,92.938c0.79-2.14,3.53-0.83,5.62-5.84c3.07-7.34-0.47-9.1-2.87-7.94"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M50.319,92.938c1.5,9.99,6.11,18.49,12.43,23.59c3.97,3.22,8.6,5.09,13.57,5.17c5.2-0.08,10.04-2.13,14.13-5.62
					c6.03-5.16,10.42-13.44,11.88-23.14"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="63.169"
                y1="87.178"
                x2="69.289"
                y2="87.178"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="88.609"
                y1="87.178"
                x2="82.489"
                y2="87.178"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M69.719,108.658c2.14,1.62,4.5,2.54,6.91,2.54c2.42,0,4.77-0.92,6.91-2.54"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M52.069,85.088c0.11,0.13,0.24,0.24,0.35,0.37c-0.02-2.97,0.26-6.84,1.47-11.17c0.68-2.49,1.54-4.62,2.38-6.42
					c5.9,1.23,12.83,3.11,20.36,6.03l0.88-8.26l23.69,19.45c0-0.02,0-0.02,0-0.02c0.89-0.95,2.08-2.4,3.12-4.38
					c0.27-0.51,0.51-1.02,0.72-1.55c2.9-7.06,1.29-15.59,0.93-16.95c-7.08-26.85-52.04-25.17-58.68,0
					c-0.35,1.35-1.93,9.73,0.85,16.75c0.23,0.6,0.5,1.18,0.8,1.75c1.05,1.98,2.24,3.43,3.13,4.38
					C52.069,85.068,52.069,85.068,52.069,85.088z"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="94.649"
                y1="69.088"
                x2="94.649"
                y2="78.828"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M18.189,168.478v-0.01c1.14-17.47,12.33-32.21,27.84-38.49c2.86-1.16,5.86-2.03,8.97-2.58"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M18.199,168.468c15.53,13.42,35.77,21.53,57.89,21.53"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M55.549,127.318c6.03,5.13,13.32,8.13,21.05,8.16"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="76.669"
                y1="136.518"
                x2="76.669"
                y2="188.768"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M98.309,127.398c3.5,0.62,6.87,1.65,10.04,3.04c14.96,6.51,25.65,20.97,26.77,38.03v0.01"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M77.219,189.998c0.69,0,1.38-0.01,2.07-0.02c21.31-0.49,40.78-8.51,55.82-21.51"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M97.759,127.318c-6.03,5.13-13.32,8.13-21.05,8.16c-0.01,0-0.01,0-0.02,0c-0.03,0-0.06,0-0.09,0"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M62.749,116.528c0,0-2.41,9.7-7.2,10.79c-0.11,0.02-0.22,0.04-0.33,0.06"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M90.819,116.528c0,0,1.93,10.09,6.94,10.79"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default EmergencyPhysicianIcon
